import { render, staticRenderFns } from "./UIIcon.vue?vue&type=template&id=390e7ba6&scoped=true"
import script from "./UIIcon.vue?vue&type=script&lang=js"
export * from "./UIIcon.vue?vue&type=script&lang=js"
import style0 from "./UIIcon.vue?vue&type=style&index=0&id=390e7ba6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "390e7ba6",
  null
  
)

export default component.exports